var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-4"},[_c('v-card-text',{staticClass:"d-flex justify-center py-8"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"32"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }